import { Link } from 'react-router-dom';
import fullLogo from '@/assets/huilen-kids-logo.webp';
import compactLogo from '@/assets/huilen-kids-mark.jpg';

type BrandProps = Readonly<{
  compact?: boolean;
  className?: string;
}>;

export function Brand({ compact = false, className = '' }: BrandProps): React.JSX.Element {
  return (
    <Link
      to="/dashboard"
      className={`group inline-flex items-center rounded-xl focus:outline-none ${className}`}
      aria-label="huilenKids.online — ir al panel"
    >
      <img
        src={compact ? compactLogo : fullLogo}
        alt="Huilen Kids"
        className={
          compact
            ? 'size-11 rounded-xl object-cover transition-transform duration-200 group-hover:scale-[1.03]'
            : 'h-11 w-[168px] object-contain object-left transition-transform duration-200 group-hover:scale-[1.01]'
        }
      />
    </Link>
  );
}
